<template>
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading">
          <p class="text-center" style="margin: 50px">
            Laden...
          </p>
        </div>
      </div>
    </div>
    <div v-if="notes.length" class="row">
      <div v-bind:key="note.id" v-for="note in notes" class="col-12">
        <div style="background: white; padding: 20px; padding-bottom: 10px; margin-bottom: 10px">
          <div class="row">
            <div class="col-12">
              <p>
                <span v-if="note.sticky === true">
                  mededeling
                </span>
                <span v-else>
                  overdracht
                </span>
                <b>
                  <span v-if="isCurrentYear(note.date)">
                    {{ this.$moment(note.date).format('dd D MMMM') }}
                  </span>
                  <span v-else>
                    {{ this.$moment(note.date).format('dd D MMMM YYYY') }}
                  </span>
                </b>
                <br>
                <span style="white-space: pre-line">{{ note.note }}</span>
                <br>
              </p>
            </div>
            <div class="col-12 text-end">
              <span v-if="isAuthorized('administration', 'transfer-notes', 'edit')" v-on:click="editNote(note)">
                <icon name="edit"></icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      Geen berichten gevonden
    </div>
    <modal v-if="showModal">
      <template v-slot:header>
        <h3 class="modal-title">
          Nieuw bericht
        </h3>
      </template>
      <template v-slot:body>
        <div style="padding: 20px; padding-top: 0">
          <label v-if="getApplicationSetting('ipad_transfer_notes') === '1'" class="me-2">
            <input type="radio" value="overdracht" v-model="noteType">
            Overdracht
          </label>
          <label v-if="getApplicationSetting('ipad_announcements') === '1'">
            <input type="radio" value="mededeling" v-model="noteType">
            Mededeling
          </label>
          <p v-if="noteType === 'overdracht'" class="alert alert-info">
            Een overdracht is een bericht gekoppeld aan een specifieke datum
          </p>
          <p v-if="noteType === 'mededeling'" class="alert alert-info">
            Een mededeling blijft staan tot dat deze verwijderd wordt
          </p>
          <label>Bericht</label>
          <textarea v-model="note" class="form-control" rows="5" placeholder="Bericht..."></textarea>
          <span v-if="noteType === 'overdracht'">
            <label>Datum</label>
            <date-picker @setDate="setDate($event)" :initDate="date"></date-picker>
          </span>
          <label>Gekoppeld aan groep(en)</label>
          <group-select :model-value="groupIds" @update:model-value="selectedGroupIds => groupIds = selectedGroupIds"/>
        </div>
      </template>
      <template v-slot:footer>
        <div v-if="error" class="text-danger mb-2">{{ error }}</div>
        <div>
          <button v-if="id && isAuthorized('administration', 'transfer-notes', 'delete')" type="button" class="btn btn-danger ms-1" v-on:click="deleteNote(id)">Verwijderen</button>
          <button type="button" class="btn btn-outline-info ms-1" v-on:click="showModal = false">Annuleren</button>
          <button v-if="isAuthorized('administration', 'transfer-notes', 'edit') || isAuthorized('administration', 'transfer-notes', 'add')" v-on:click="setNote()" type="button" class="btn btn-info ms-1">Opslaan</button>
        </div>
      </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal'
import DatePicker from '@/components/Date-Picker'
import Icon from '@/components/Icon'
import GroupSelect from "./Group-Select";
export default {
  name: 'transfer-notes-list',
  components: {
    GroupSelect,
    DatePicker,
    Icon,
    Modal
  },
  props: {
    notes: {
      type: Array,
      default: () => {[]}
    },
    filterBy: {
      type: String,
      default: 'overdracht'
    },
    openDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      error: null,
      id: null,
      note: null,
      date: null,
      showModal: false,
      noteType: 'overdracht',
      groupIds: []
    }
  },
  watch: {
    openDialog (val) {
      this.error = null;

      if (val === true) {
        this.startNewNote()
      }
    },
    showModal (show) {
      if (show === false) {
        this.groupIds = []
      }
    }
  },
  methods: {
    startNewNote () {
      this.id = null
      this.note = null
      this.date = null
      this.noteType = this.filterBy
      this.showModal = true
      this.$emit('dialogAddTransferNoteShow', false)
    },
    editNote (note) {
      this.id = note.id
      this.note = note.note
      this.date = note.date
      if (note.sticky === true) {
        this.noteType = 'mededeling'
      } else {
        this.noteType = 'overdracht'
      }
      this.groupIds = note.id_group
      this.showModal = true
    },
    setDate (date) {
      this.date = date
    },
    isCurrentYear (date) {
      if (this.$moment(date).format('YYYY') == this.$moment().format('YYYY')) {
        return true;
      }
      return false;
    },
    setNote () {
      var date = this.$moment().format('YYYY-MM-DD')
      if (this.date) {
        date = this.$moment(this.date).format('YYYY-MM-DD')
      }
      var sticky = false
      if (this.noteType === 'mededeling') {
        sticky = true
        date = this.$moment().format('YYYY-MM-DD')
      }
      this.isLoading = true
      if (this.id) {
        this.$request.put('/transfer-notes/' + this.id, {
          id_group: this.groupIds.join(','),
          date: date,
          sticky: sticky,
          note: this.note
        }).then((response) => {
          this.isLoading = false
          if (response.data) {
            this.showModal = false
            this.note = null
            this.$store.dispatch('getTransferNotes', {id: this.id})
          } else {
            this.error = 'Er is iets misgegaan. Heb je alle velden ingevuld?';
          }
        })
      } else {
        this.$request.post('/transfer-notes', {
          id_group: this.groupIds.join(','),
          date: date,
          sticky: sticky,
          note: this.note
        }).then((response) => {
          this.isLoading = false
          if (response.data) {
            this.showModal = false
            this.note = null
            this.$store.dispatch('getTransferNotes', {id: response.data.id})
          } else {
            this.error = 'Er is iets misgegaan. Heb je alle velden ingevuld?';
          }
        })
      }
    },
    deleteNote (id) {
      if (confirm('Weet je zeker dat je deze overdracht / mededeling voor alle groepen wilt verwijderen?') !== true) {
        return
      }
      this.isLoading = true
      this.$request.delete('/transfer-notes/' + id)
      .then((response) => {
        this.isLoading = false
        this.showModal = false
        if (response.data) {
          this.$store.commit('DELETE_TRANSFER_NOTE_BY_ID', id)
        }
      })
    }
  },
}
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>
